module.exports = __webpack_public_path__ + "img/home-2-people.65977158.png";